export default __webpack_public_path__ + "static/media/Step 1_unfold.aa4fc8bf.stl";